/*
 *
 * Notification constants
 *
 */

const prefix = 'ui/containers/Notification';

export const ADD_FLAG = `${prefix}/ADD_FLAG`;
export const REMOVE_FLAG = `${prefix}/REMOVE_FLAG`;
